const isFilledString = (value: unknown): value is string => typeof value === "string" && value !== "";

export default isFilledString;
